// CONTEXTS
import { UsersProvider } from "../../contexts/users/users.context";
import { SelectedUsersProvider } from "../../contexts/users/selectedUsers.users.context";
// COMPONENTS
import Layout from "../../pages/users/layout.users.page";

const UsersLayout = () => {
  return (
    <UsersProvider>
      <SelectedUsersProvider>
        <Layout />
      </SelectedUsersProvider>
    </UsersProvider>
  );
};

export default UsersLayout;
